import request from '@/utils/request.util';
import * as Cache from '@/utils/cache.util';
import { RequestData, ResponseData } from '@/typings/request.type';
import { FetchType } from '@/typings/api.type';
import { AccountModule } from '@/store/modules/account';
import Vue from 'vue';

/**
 * 调用远程接口获取数据
 * @param {Object} 请求参数
 * @param {String} 请求类型
 * @returns T
 */
const fetch = async <T>(req: RequestData, type: FetchType): Promise<T | null> => {
  // 从缓存中获取token
  const token = AccountModule.token || Cache.getToken('manager');
  token && request.setToken(token);
  const client: any = request[type];
  const response: ResponseData<any> = await client(req);
  if (response && response.code == 0) {
    if (!response.data) {
      return response as any;
    }
    return response.data as T;
  }
  return Promise.reject(response);
};

/**
 * 发送get请求
 * @param req 请求参数
 */
const get = async <T>(req: RequestData): Promise<T | null> => {
  return fetch<T>(req, FetchType.GET);
};

/**
 * 发送post请求
 * @param req 请求参数
 */
const post = async <T>(req: RequestData): Promise<ResponseData<T> | null> => {
  return fetch<ResponseData<T>>(req, FetchType.POST);
};

/**
 * 发送put请求
 * @param req 请求参数
 */
const put = async <T>(req: RequestData): Promise<ResponseData<T> | null> => {
  return fetch<ResponseData<T>>(req, FetchType.PUT);
};

/**
 * 发送delete请求
 * @param req 请求参数
 */
const del = async <T>(req: RequestData): Promise<ResponseData<T> | null> => {
  return fetch<ResponseData<T>>(req, FetchType.DELETE);
};
/**
 * 上传请求
 * @param req 请求参数
 */
const upload = async <UploadResponseData>(req: RequestData): Promise<UploadResponseData | null> => {
  return fetch<UploadResponseData>(req, FetchType.UPLOAD);
};

let Client = {
  get,
  post,
  upload,
  fetch,
  put,
  delete: del,
};

export { Client };
